import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from '../config/firebaseConfig';

// Context'i oluşturuyoruz.
const AuthContext = createContext();

// Diğer bileşenlerin context'e kolayca erişmesi için özel bir hook (custom hook).
export const useAuth = () => {
    return useContext(AuthContext);
};

// Tüm uygulamayı sarmalayacak ve kimlik bilgilerini sağlayacak olan Provider bileşeni.
export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null); // Firebase Auth kullanıcısı
    const [userData, setUserData] = useState(null);       // Firestore kullanıcı verisi (rol, isim vb.)
    const [loading, setLoading] = useState(true);         // İlk yükleme durumu

    useEffect(() => {
        let unsubscribeSnapshot = null;

        // onAuthStateChanged, kullanıcının giriş/çıkış yapması gibi kimlik doğrulama
        // durumundaki her değişikliği dinler.
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);

            // Eğer kullanıcı giriş yapmışsa...
            if (user) {
                // Firestore'daki 'users' koleksiyonundan ilgili kullanıcının belgesine
                // bir dinleyici (listener) bağlıyoruz.
                const userDocRef = doc(db, 'users', user.uid);
                
                // onSnapshot sayesinde, bu belgedeki herhangi bir değişiklik
                // (örneğin profil güncellemesi) anında burayı tetikler.
                unsubscribeSnapshot = onSnapshot(
                    userDocRef, 
                    (doc) => {
                        if (doc.exists()) {
                            // Belgeden gelen veriyi userData state'ine kaydediyoruz.
                            setUserData({ uid: doc.id, ...doc.data() });
                        } else {
                            // Bu durum normalde olmamalı, ama bir hata olursa diye kontrol ediyoruz.
                            console.error("Kullanıcı için Firestore dokümanı bulunamadı!");
                            setUserData(null);
                        }
                        // Firestore'dan veri geldiğinde yükleme işlemini bitiriyoruz.
                        setLoading(false);
                    },
                    (error) => {
                        // Hata yakalama: İlk yüklemede takılı kalmasını engeller
                        console.error("Firestore veri çekme hatası:", error);
                        setUserData(null);
                        setLoading(false);
                    }
                );
            } else {
                // Eğer kullanıcı giriş yapmamışsa (veya çıkış yapmışsa)...
                setUserData(null); // Profil verilerini temizle.
                setLoading(false); // Yükleme işlemini bitir.
                if (unsubscribeSnapshot) unsubscribeSnapshot();
            }
        });

        // Ana cleanup fonksiyonu: Bileşen unmount olduğunda
        // onAuthStateChanged ve Firestore dinleyicisini kapatır.
        return () => {
            unsubscribeAuth();
            if (unsubscribeSnapshot) unsubscribeSnapshot();
        };
    }, []); // Boş dizi, bu useEffect'in sadece component ilk render edildiğinde çalışmasını sağlar.

    // Uygulamanın geri kalanına sağlanacak olan değerler.
    const value = {
        currentUser,
        userData, // Artık userData (rol dahil) uygulama genelinde anlık olarak güncel.
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {/* İlk kimlik doğrulama kontrolü bitene kadar alt bileşenleri (children) render etme. */}
            {!loading && children}
        </AuthContext.Provider>
    );
};